module.exports = __webpack_public_path__ + "img/23.9afd212d.png";